import React from "react";
import styled from "styled-components";

export default styled.h2`
    color: #515151;
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    font-family: 'Effra', sans-serif;
    margin-top: 0;

`;